import {
  Box,
  Card,
  Divider,
  IconButton,
  Modal,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography
} from "@mui/material";
import TimesheetSkeletonLoader from "../shared/components/TimesheetSkeletonLoader";

import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useState } from "react";
import { BIGrey } from "../../../assets/helpers";
import { useSelector } from "react-redux";
import PictureViewer from "../../../common/PictureViewer";
import { Postrequestcall } from "../../../request/Postrequest";
import { FETCH_CLIENT_TIMESHEETJOBS_ACTIVITIES_EMPLOYEE } from "../../../constant/Apipath";
import { ClientEnglishFallback } from "../../constant/ClientEnglishFallback";

export default function ViewEmployeedetail({ isOpen, onClose, getItem }) {
  const { loginData, multiLanguageData } = useSelector((state) => state?.main);
  const TOKEN = loginData?.accessToken;
  const USER_ID = loginData?.userInformation?.UserId;

  const { TEXT_IN, TEXT_OUT, TEXT_HOURS, TEXT_EMPLOYEE, TEXT_MILEAGE } =
    ClientEnglishFallback?.AddTimesheetModal(multiLanguageData?.AddTimesheetModal || {});

  const [data, setData] = useState([]);
  const [loader, setLoader] = useState(true);

  const [pictureViewerOpen, setPictureViewerOpen] = useState(false);
  const [imageIndex, setImageIndex] = useState(0);

  useEffect(() => {
    if (isOpen === true) {
      showSignature(getItem);
    }
  }, [isOpen]);

  const showSignature = async (item) => {
    try {
      const getObj = {
        PageNr: 1,
        NrOfRecPerPage: 20,
        FullSearch: "",
        UserId: USER_ID,
        IncludeRecordNr: true,
        FetchAllowedRecordsOnly: true,
        SearchList: [
          {
            ClientEmployeeId: item?.clientEmployeeId,
            ClientTimesheetId: item?.clientTimesheetId
          }
        ]
      };
      const getResponse = await Postrequestcall(
        FETCH_CLIENT_TIMESHEETJOBS_ACTIVITIES_EMPLOYEE,
        getObj,
        TOKEN
      );
      if (getResponse.status === 200) {
        setData(getResponse?.data?.data[0]);
      }
    } catch (error) {
    } finally {
      setLoader(false);
    }
  };

  const ImgUrl = (file) => {
    try {
      let url = URL?.createObjectURL(file);
      return url;
    } catch (error) {
      return file;
    }
  };

  const pictureListArray =
    data?.pictureList?.map((item) => {
      return {
        src: item?.fileUrl || ImgUrl(item?.file)
      };
    }) || [];

  return (
    <>
      <PictureViewer
        isOpen={pictureViewerOpen}
        viewerIndex={imageIndex}
        pictures={pictureListArray}
        onClose={() => setPictureViewerOpen(false)}
      />
      <Modal
        open={isOpen}
        onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <Box
          sx={{
            padding: {
              xs: "10px",
              xl: "15px",
              lg: "15px",
              md: "15px",
              sm: "10px"
            },
            maxHeight: "650px",
            overflow: "auto"
          }}
          className="client-modal-responsive">
          {loader ? (
            <Box sx={{ width: "100%" }}>
              <TimesheetSkeletonLoader variant="modal" />
            </Box>
          ) : (
            <>
              <Stack sx={{ display: "flex",  margin: "5px 0px",  justifyContent: "space-between", alignItems: "center" }}  direction={"row"} >
                <IconButton size="small" onClick={onClose}>
                  <CloseIcon />
                </IconButton>
              </Stack>
              <Stack>
                <Typography variant="h6">
                  {data?.clientJobCode} - {data?.clientJobName}
                </Typography>
              </Stack>
              <Table
                sx={{
                  minWidth: 350,
                  "& th": {
                    color: BIGrey,
                    padding: "0px 10px",
                    borderBottom: "0px"
                  },
                  "& td": {
                    padding: "0px 10px"
                  }
                }}
                aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell variant="h6">{TEXT_IN}</TableCell>
                    <TableCell variant="h6">{TEXT_OUT}</TableCell>
                    <TableCell variant="h6" sx={{ textAlign: "end" }}>
                      {TEXT_HOURS}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow sx={{ "& td, & th": { border: 0, padding: "7px" } }}>
                    <TableCell>{data?.clockInTime}</TableCell>
                    <TableCell>{data?.clockOutTime}</TableCell>
                    <TableCell sx={{ textAlign: "end" }}>
                      <TextField
                        hiddenLabel
                        size="small"
                        placeholder="--:--"
                        value={data?.activityHours?.toString()} // Bind the input value to the state
                        sx={{
                          "& fieldset": { border: "none" },
                          "& input": { textAlign: "center" }
                        }}
                        disabled
                        style={{
                          width: "80px",
                          backgroundColor: "rgba(0, 0, 0, 0.08)",
                          borderRadius: "5px",
                          borderColor: "transparent"
                        }}
                      />
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
              <Stack>
                <Typography>{data?.notes || "---"}</Typography>
                {data?.pictureList?.length > 0 && (
                  <Stack
                    direction="row"
                    sx={{ gap: 1, width: "100%", marginTop: "10px", overflowX: "auto" }}>
                    {data?.pictureList.map((url, index) => (
                      <img
                        onClick={() => {
                          setImageIndex(index);
                          setPictureViewerOpen(true);
                        }}
                        key={index}
                        src={url?.thumbFileUrl}
                        alt={`Image ${index + 1}`}
                        style={{
                          maxWidth: "100px",
                          maxHeight: "100px",
                          minWidth: "100px",
                          minHeight: "100px",
                          objectFit: "cover",
                          cursor: "pointer",
                          borderRadius: "10px"
                        }}
                      />
                    ))}
                  </Stack>
                )}
              </Stack>
              <Divider style={{ height: 1, borderColor: "#cccccc", marginTop: 10 }} />
              <Table
                sx={{
                  minWidth: 350,
                  margin: "10px 0px",
                  "& th": {
                    color: BIGrey,
                    padding: "0px 10px",
                    borderBottom: "0px"
                  },
                  "& td": {
                    padding: "0px 10px"
                  }
                }}
                aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell variant="h6">{TEXT_EMPLOYEE}</TableCell>
                    <TableCell variant="h6" sx={{ textAlign: "end" }}>
                      {TEXT_MILEAGE}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow sx={{ "& td, & th": { border: 0, padding: "7px" } }}>
                    <TableCell>{data?.clientEmployeeName}</TableCell>
                    <TableCell sx={{ textAlign: "end" }}>
                      {data?.mileage + " " + data?.mileageUnit}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
              <Card
                className="pagelist-content"
                sx={{ background: "transparent", display: "flex", justifyContent: "center" }}>
                <img
                  loading="lazy"
                  src={data?.signature}
                  alt={"NO data"}
                  style={{
                    cursor: "pointer",
                    height: "100px",
                    borderRadius: "10px",
                    marginTop: "10px"
                  }}
                />
              </Card>
            </>
          )}
        </Box>
      </Modal>
    </>
  );
}
